import './init_frontend_sentry';
import '@/modules/posthog/posthog_module';
import '../register_splash_screen';

import springboard from 'springboard';

import 'springboard/modules/files/files_module';

import '@/modules/files/files_module';
import {migrations, databaseVersion} from '@/store/db/imported_migrations/imported_migrations';

import '@/modules/login_flow/login_flow_module';
import '@/modules';

import {createOfflineBrowserFileClient, createOfflineBrowserSqliteDialect} from './browser_offline_shared';
import {migrateSqliteDB} from '@/store/init_sqlite_db';
import {seedUserData} from '@/store/seed_user_data';
import {dataMigrations} from '@/store/db/data_migrations/run_data_migrations';

(window as unknown as {DISABLE_TRIM_FEATURE?: boolean}).DISABLE_TRIM_FEATURE = true;

springboard.registerModule('OfflineBrowserInit', {}, async (moduleAPI) => {
    moduleAPI.deps.core.showError = console.error;
    const kyselyModule = moduleAPI.deps.module.moduleRegistry.getModule('Kysely');

    const sqlDialect = await createOfflineBrowserSqliteDialect();
    kyselyModule.setDialect(sqlDialect);

    const selectors = kyselyModule.selectors;
    const fileClient = await createOfflineBrowserFileClient(selectors);

    const msFilesModule = moduleAPI.deps.module.moduleRegistry.getModule('MSFiles');
    msFilesModule.setFileClient(fileClient);

    const db = kyselyModule.db();

    await migrateSqliteDB(db, migrations.map(m => ({
        name: m.name,
        getMigration: async () => m.migration,
    })), dataMigrations, fileClient.getFileSrc, (arrayBuffer) => {
        return new AudioContext().decodeAudioData(arrayBuffer);
    });

    // const userData = await seedUserData(db, true);
    const workspacesModule = moduleAPI.deps.module.moduleRegistry.getModule('Workspaces');
    if (!workspacesModule.currentWorkspaceIdState.getState()) {
        // workspacesModule.setCurrentWorkspaceId(userData.workspace.id);
    }

    return {};
});
